module.exports = __webpack_public_path__ + "img/cmp-close.c2741d12.svg";